import { NgModule } from '@angular/core';

import { DotComponent } from './dot.component';

@NgModule({
  imports: [],
  declarations: [DotComponent],
  exports: [DotComponent],
})
export class DotModule {}
export { DotComponent } from './dot.component';
